import { Product } from 'components/Catalog/Interfaces/List/IListResponse';
import { IGtmList, IGtmProduct } from 'components/SeoSuite/interfaces/IGtmEventDetail';

/**
 * Google Analytics counts list positions from 1, and expects them to stay stable across pages.
 */
export const toGtmProducts = (products: Product[], list?: IGtmList, firstIndex = 1): IGtmProduct[] =>
    products.map((product, i) => ({
        sku: product.sku,
        name: product.name,
        price: product.priceValue,
        index: firstIndex + i,
        list,
    }));
